export default __webpack_public_path__ + "static/media/avatar2.06cb8045.png";